exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FtInput input {\n  color: #515a6e;\n  border: 1px solid #dcdee2;\n}\n", ""]);
